import { LineInputType } from 'graphql/models/generated';

export function consolidateLineUpdates(
  lineUpdates: LineInputType[]
): LineInputType[] {
  const updatesByLine: Record<LineInputType['id'], LineInputType> = {};

  lineUpdates.forEach((line) => {
    if (Object.prototype.hasOwnProperty.call(updatesByLine, line.id)) {
      const mergedProps = updatesByLine[line.id].properties;
      if (mergedProps) {
        line.properties?.forEach((prop) => {
          const merged = mergedProps.find((p) => p.key === prop.key);
          if (merged) {
            // last update wins
            merged.value = prop.value;
          } else {
            mergedProps.push(prop);
          }
        });
      }
    } else {
      updatesByLine[line.id] = line;
    }
  });

  return Object.keys(updatesByLine).map((id) => updatesByLine[id]);
}
